import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CommonTable from "../../common/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import customerActions from "../../redux/customer/actions";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import masterActions from "../../redux/master/actions";
import * as XLSX from "xlsx";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import TablePagination from "../../common/tablePagination";
import { itemsPerPage } from "../../utils/constants";
import objectionTrackerActions from "../../redux/objectionTracker/actions";

export default function Index() {
  const dispatch = useDispatch();
  const [courseid, setCourseId] = useState(0);
  const [rollNo, setRollNo] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  const { courseList } = useSelector((state) => state.masterReducer);

  const { objectionPayments } = useSelector((state) => state.customerReducer);
  const { refundStatus } = useSelector(
    (state) => state.objectionTrackerReducer
  );

  const [courseError, setCourseError] = useState("");
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
    dispatch({ type: objectionTrackerActions.GET_REFUND_STATUS });
  }, [objectionPayments]);

  const onChangeCourse = (e) => {
    setCourseId(e.target.value);
    setCourseError("");
  };

  const handleRollNoChange = (e) => {
    setRollNo(e.target.value);
  };

  const handleGenerate = () => {
    if (courseid === 0) {
      setCourseError("Course is required");
      return;
    }

    dispatch({
      type: customerActions.GET_OBJECTION_PAYMENT_REPORT,
      payload: { courseid: courseid, rollno: rollNo },
    });
  };

  //   const handleDownloadExcel = () => {
  //     if (!objectionPayments || objectionPayments.length === 0) return;

  //     const data = objectionPayments.map((item) => ({
  //       "Sr.No": objectionPayments.indexOf(item) + 1,
  //       "Application No": item?.application_no ?? "N/A",
  //       "Candidate Name": item?.candidate_name ?? "N/A",
  //       "Exam Name": item?.exam_name ?? "N/A",
  //       "Exam Date": item?.exam_date
  //         ? new Date(item.exam_date).toLocaleDateString("en-GB")
  //         : "N/A",
  //       "Question ID": item?.question_id ?? "N/A",
  //       "Objection Status": item?.objection_status ?? "N/A",
  //       "Payment Status": item?.payment_status ?? "N/A",
  //     }));

  //     const worksheet = XLSX.utils.json_to_sheet(data);
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(
  //       workbook,
  //       worksheet,
  //       "Objection Payment Report"
  //     );

  //     const wscols = [
  //       { wch: 10 },
  //       { wch: 20 },
  //       { wch: 20 },
  //       { wch: 20 },
  //       { wch: 20 },
  //       { wch: 10 },
  //       { wch: 15 },
  //       { wch: 15 },
  //     ];
  //     worksheet["!cols"] = wscols;

  //     const range = XLSX.utils.decode_range(worksheet["!ref"]);
  //     for (let C = range.s.c; C <= range.e.c; ++C) {
  //       const address = XLSX.utils.encode_cell({ r: 0, c: C });
  //       if (!worksheet[address]) continue;
  //       worksheet[address].s = {
  //         font: { bold: true },
  //         alignment: { horizontal: "center", vertical: "center" },
  //       };
  //     }

  //     XLSX.writeFile(workbook, "Objection Payment Report.xlsx");
  //   };

  const tableData = Array.isArray(objectionPayments)
    ? objectionPayments
        .filter((item) => item?.objection_status === "Valid")
        .map((item, index) => ({
          srNo: index + 1,
          application_no: item?.application_no ?? "N/A",
          candidate_name: item?.candidate_name ?? "N/A",
          exam_name: item?.exam_name ?? "N/A",
          exam_date: item?.exam_date
            ? new Date(item.exam_date).toLocaleDateString("en-GB")
            : "N/A",
          question_id: item?.question_id ?? "N/A",
          objection_status: item?.objection_status ?? "N/A",
          payment_status: item?.payment_status ?? "N/A",
          rollno: item?.rollno ?? "N/A",
        }))
    : [];

    const checkRefundStatus = (rollno, question_id) => {
      if (!refundStatus?.data) return false;
      
      if (Array.isArray(refundStatus.data)) {
        const refundRecord = refundStatus?.data?.find(
          (item) =>
            item.rollno === rollno &&
            item.questionid?.includes(parseInt(question_id))
        );
        return refundRecord?.refundstatus === 2;
      }
      
      return false;
    };
  let applicationStatusColumns = [
    { name: "Sr.No", dataIndex: "srNo" },
    { name: "Candidate Roll No", dataIndex: "rollno" },
    { name: "Application No", dataIndex: "application_no" },
    { name: "Candidate Name", dataIndex: "candidate_name" },
    { name: "Exam Name", dataIndex: "exam_name" },
    { name: "Exam Date", dataIndex: "exam_date" },
    { name: "Question ID", dataIndex: "question_id" },
    { name: "Objection Status", dataIndex: "objection_status" },
    { name: "Payment Status", dataIndex: "payment_status" },
    {
      name: (
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="body2" fontWeight="bold">
            Refund
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body1" mt={1} sx={{ fontSize: "15px" }}>
              Select All
            </Typography>
            <input
              type="checkbox"
              checked={
                tableData.length > 0 &&
                selectedRows.length ===
                  tableData.filter(
                    (item) => !checkRefundStatus(item.rollno, item.question_id)
                  ).length
              }
              onChange={(e) => {
                if (e.target.checked) {
                  // Only select rows that aren't already refunded
                  setSelectedRows(
                    tableData
                      .filter(
                        (item) =>
                          !checkRefundStatus(item.rollno, item.question_id)
                      )
                      .map((item) => item.srNo)
                  );
                } else {
                  setSelectedRows([]);
                }
              }}
            />
          </Box>
        </Box>
      ),
      dataIndex: "checkbox",
      render: (_, record) => {
        const isRefunded = checkRefundStatus(record.rollno, record.question_id);
        return (
          <input
            type="checkbox"
            checked={isRefunded || selectedRows.includes(record.srNo)}
            disabled={isRefunded}
            onChange={(e) => {
              if (isRefunded) return;

              if (e.target.checked) {
                setSelectedRows([...selectedRows, record.srNo]);
              } else {
                setSelectedRows(
                  selectedRows.filter((id) => id !== record.srNo)
                );
              }
            }}
          />
        );
      },
    },
  ];

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = tableData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(tableData?.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(value);
  };

  const InitializeRefund = () => {
    if (selectedRows.length === 0) {
      setOpenDialog(true);
      return;
    }


    // Get all selected items from tableData
    const selectedItems = tableData.filter((item) =>
      selectedRows.includes(item.srNo)
    );

    // Group selected items by rollno
    const groupedByRollNo = selectedItems.reduce((acc, item) => {
      if (!acc[item.rollno]) {
        acc[item.rollno] = [];
      }
      acc[item.rollno].push(item.question_id);
      return acc;
    }, {});


    // Prepare payload for each rollno
    const payloads = Object.entries(groupedByRollNo).map(
      ([rollno, questionid]) => {
        const payload = {
          rollno,
          questionid,
          checkedCount: questionid.length,
        };
        return payload;
      }
    );


    // Dispatch action for each payload
    payloads.forEach((payload) => {
      dispatch({
        type: objectionTrackerActions.INITIALIZE_REFUND,
        payload: payload,
      });
    });

    setSelectedRows([]);
  };

  return (
    <>
      <Box
        sx={{
          margin: "1rem auto",
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderRadius: "8px",
          padding: "10px",
        }}
      >
        <Card sx={{ p: 2 }}>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl error={!!courseError} sx={{ width: "100%" }}>
                <Select
                  size="small"
                  onChange={onChangeCourse}
                  value={courseid}
                  defaultValue={0}
                  sx={{ height: "56px" }}
                >
                  <MenuItem value={0} selected>
                    Select Course <span style={{ color: "red" }}>*</span>
                  </MenuItem>
                  {courseList?.all
                  ?.filter((course) => course.isactive === "1")
                    ?.map((course, i) => (
                      <MenuItem key={i} value={course.courseid}>
                        {course.coursename}
                      </MenuItem>
                    ))}
                </Select>
                {courseError && (
                  <Typography variant="caption" color="error">
                    {courseError}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl sx={{ width: "100%" }} variant="outlined">
                <InputLabel htmlFor="search-roll-no">
                  Search by Roll No
                </InputLabel>
                <OutlinedInput
                  id="search-roll-no"
                  value={rollNo}
                  onChange={handleRollNoChange}
                  label="Search by Roll No"
                />
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              mt={1}
              sx={{ display: "flex", gap: 1 }}
            >
              <Box sx={{ marginTop: { xs: 2, sm: 0 } }}>
                <BluePrimaryButton
                  title={"Generate"}
                  handleSubmit={handleGenerate}
                />
              </Box>
              {/* <Button
                onClick={handleDownloadExcel}
                sx={{
                  backgroundColor: "green",
                  color: "white",
                  height: "40px",
                  borderRadius: "11px",
                  "&:hover": { backgroundColor: "darkgreen" },
                }}
              >
                Download Excel
              </Button> */}
            </Grid>
          </Grid>

          <CommonTable
            columnData={applicationStatusColumns}
            tableData={currentItems}
          />
          <Box display="flex" justifyContent="flex-end" sx={{ marginRight: 2 }}>
            <MauvelousPrimaryButton
              title="Initialize Refund"
              handleClick={InitializeRefund}
            />
          </Box>
        </Card>
        <TablePagination
          pageCount={pageCount}
          handlePageChange={handlePageChange}
          currentPage={currentPage}
        />
      </Box>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ textAlign: "center", fontSize: "17px" }}
        >
          {"Refund Initialization"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select at least one record to initialize refund.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenDialog(false)}
            color="primary"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
